export enum FunnelViewMode {
  PROMOTION = 'PROMOTION',
  DETAILS = 'DETAILS',
  SHARED = 'SHARED',
  ONBOARDING = 'ONBOARDING',
}
